import { MetaLayerDefinition } from '@agissc/ktag-map';
import useAppState from '../../AppStore';

const useToggleTopicLayer = () => {
  const toggleTopicLayer = useAppState((state) => state.toggleTopicLayer);
  const addEsriLayer = useAppState((state) => state.addTopicLayer);
  const removeSubTopicLayerSetting = useAppState(
    (state) => state.removeSubTopicLayerSetting,
  );

  const addTopicLayer = async (topic: MetaLayerDefinition) => {
    if (topic.type === 'esriMapServer') {
      addEsriLayer(topic.id, topic.isPublic ?? true);
      return;
    }

    toggleTopicLayer(topic.id, topic.isPublic ?? true);
  };

  const removeTopicLayer = async (topic: MetaLayerDefinition) => {
    if (topic.type === 'esriMapServer') {
      removeSubTopicLayerSetting(topic.id);
      return;
    }

    toggleTopicLayer(topic.id);
  };

  return { addTopicLayer, removeTopicLayer };
};

export default useToggleTopicLayer;
